import { ReactElement } from "react";

/**
 * Iterates a component with 'x' amount times.
 * Use it to repeate 3 or more identical component with more simpler way
 */
function repeatComponent(count: number, component: ReactElement, keyName?: string): ReactElement[] {
  return Array.from(Array(count)).map((_, i) => ({ ...component, key: keyName ? `${keyName}_${i}` : i }));
}

export { repeatComponent };
